export const DEFAULT_RELEVANT_EVENTS_COUNT = 5;
export const MAIN_FIELDS_COLUMN_ID = "__MAIN_FIELDS__";
